import React from 'react';

import './SrCheckboxLoadingSpinner.less';

const SrCheckboxLoadingSpinner = () => {
  return <span styleName="SrCheckboxLoadingSpinner" />;
};

SrCheckboxLoadingSpinner.displayName = 'SrCheckboxLoadingSpinner';

export default SrCheckboxLoadingSpinner;
